export const CompetitionModalities = [
  'Dispensa de licitação',
  'Pregão presencial',
  'Pregão eletrônico',
  'Carta convite',
  'Cotação'
];
